"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.driverOnboardingRequestSchema = exports.driverOnboardingResponseSchema = exports.createDriverOnboardingRequestSchema = exports.DriverOnboardingErrorCode = exports.DriverOnboardingDeliveryStatus = exports.DriverOnboardingLanguage = void 0;
const zod_1 = require("zod");
/** BCP 47 tags, matching the mobile app's `LanguageCountryCode`. */
var DriverOnboardingLanguage;
(function (DriverOnboardingLanguage) {
    DriverOnboardingLanguage["DE"] = "de-DE";
    DriverOnboardingLanguage["EN"] = "en-US";
    DriverOnboardingLanguage["PL"] = "pl-PL";
    DriverOnboardingLanguage["RO"] = "ro-RO";
    DriverOnboardingLanguage["RU"] = "ru-RU";
    DriverOnboardingLanguage["TR"] = "tr-TR";
    DriverOnboardingLanguage["FR"] = "fr-FR";
    DriverOnboardingLanguage["ES"] = "es-ES";
    DriverOnboardingLanguage["NL"] = "nl-NL";
    DriverOnboardingLanguage["CS"] = "cs-CZ";
})(DriverOnboardingLanguage || (exports.DriverOnboardingLanguage = DriverOnboardingLanguage = {}));
var DriverOnboardingDeliveryStatus;
(function (DriverOnboardingDeliveryStatus) {
    DriverOnboardingDeliveryStatus["PENDING"] = "PENDING";
    DriverOnboardingDeliveryStatus["SENT"] = "SENT";
    DriverOnboardingDeliveryStatus["FAILED"] = "FAILED";
})(DriverOnboardingDeliveryStatus || (exports.DriverOnboardingDeliveryStatus = DriverOnboardingDeliveryStatus = {}));
var DriverOnboardingErrorCode;
(function (DriverOnboardingErrorCode) {
    DriverOnboardingErrorCode["INVALID_REQUEST"] = "INVALID_REQUEST";
    DriverOnboardingErrorCode["COMPANY_NOT_FOUND"] = "COMPANY_NOT_FOUND";
    DriverOnboardingErrorCode["UNSUPPORTED_COUNTRY"] = "UNSUPPORTED_COUNTRY";
    DriverOnboardingErrorCode["NO_SEATS_LEFT"] = "NO_SEATS_LEFT";
    DriverOnboardingErrorCode["RATE_LIMITED"] = "RATE_LIMITED";
    DriverOnboardingErrorCode["DELIVERY_FAILED"] = "DELIVERY_FAILED";
})(DriverOnboardingErrorCode || (exports.DriverOnboardingErrorCode = DriverOnboardingErrorCode = {}));
/**
 * Body of `POST /onboarding/{companyName}`. `mobileNumber` stays unvalidated
 * beyond length here: only the backend can tell an unsupported country apart from
 * a malformed number, and the two need distinct error codes.
 */
exports.createDriverOnboardingRequestSchema = zod_1.z.object({
    firstName: zod_1.z.string().trim().min(1).max(100),
    lastName: zod_1.z.string().trim().min(1).max(100),
    mobileNumber: zod_1.z.string().trim().min(6).max(30),
    language: zod_1.z.nativeEnum(DriverOnboardingLanguage),
    consent: zod_1.z.literal(true),
});
/** The access key is never returned — it only ever reaches the driver's phone. */
exports.driverOnboardingResponseSchema = zod_1.z.object({
    status: zod_1.z.nativeEnum(DriverOnboardingDeliveryStatus),
});
/** `DriverOnboardingRequestEntity` implements the inferred type, so the two cannot drift. */
exports.driverOnboardingRequestSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    companyId: zod_1.z.string().uuid(),
    accessKeyId: zod_1.z.string().uuid().nullable(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    mobileNumber: zod_1.z.string(),
    language: zod_1.z.nativeEnum(DriverOnboardingLanguage),
    consentAt: zod_1.z.date(),
    deliveryStatus: zod_1.z.nativeEnum(DriverOnboardingDeliveryStatus),
    providerMessageId: zod_1.z.string().nullable(),
    deliveryError: zod_1.z.string().nullable(),
    createdAt: zod_1.z.date(),
    sentAt: zod_1.z.date().nullable(),
});
//# sourceMappingURL=driverOnboarding.js.map